'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useLookupsStore } from '@repo/store/useLookupsStore'

export const UserSingleSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  label = 'User',
  sx,
  size = 'small',
  required,
  errors = {},
  name = 'userId',
  clearable = false,
  searchable = true
}) => {
  const { fetchAllUsers, allUsers } = useLookupsStore()
  const [options, setOptions] = useState(testData || allUsers || [])
  const [selectedValue, setSelectedValue] = useState(null)

  useEffect(() => {
    if (testData) return
    setOptions(allUsers || [])
  }, [testData, allUsers])

  useEffect(() => {
    if (testData || allUsers?.length) return
    fetchAllUsers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, allUsers])

  useEffect(() => {
    if (!value) {
      setSelectedValue(null)
      return
    }
    const items = testData || allUsers || []
    const match = items.find((u) => String(u?.userId) === String(value))
    if (match) {
      setSelectedValue({
        ...match,
        label: match.description || String(match.userId),
        value: match.userId
      })
    } else {
      setSelectedValue(null)
    }
  }, [value, allUsers, testData])

  return (
    <div data-testid="UserSingleSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label={label}
        onChange={(newVal) => {
          onChange(newVal?.userId ?? null)
          setSelectedValue(newVal)
        }}
        labelKey="description"
        valueKey="userId"
        idLabelKey="emailAddress"
        items={options}
        value={selectedValue}
        searchable={searchable}
        clearable={clearable}
        name={name}
        size={size}
        required={required}
        errors={errors}
        sx={{ ...sx }}
      />
    </div>
  )
}

UserSingleSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.object,
  name: PropTypes.string,
  clearable: PropTypes.bool,
  searchable: PropTypes.bool
}
